import type { Config } from "@measured/puck";
import { Heading } from "@/lib/puck/blocks/Heading";
import { Space } from "@/lib/puck/blocks/Space";
import { Text } from "@/lib/puck/blocks/Text";
import { Image } from "@/lib/puck/blocks/Image";
import { Editor } from "@/lib/puck/blocks/Editor";
import { Accordion } from "@/lib/puck/blocks/Accordion";

export const puckConfig: Config = {
  categories: {
    typography: {
      components: ["Heading", "Text", "Editor"],
    },
    media: {
      components: ["Image"],
    },
    layout: {
      components: ["Space"],
    },
    surfaces: {
      components: ["Accordion"],
    },
  },
  components: {
    Heading,
    Text,
    Editor,
    Image,
    Space,
    Accordion,
  },
};
